var _style;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoMSorizzWhite1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1400,
    height: 300,
    viewBox: "0 0 370.417 79.375",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1084",
    transform: "translate(-10.979 -28.747)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1463",
    transform: "translate(-51.657 -118.23) scale(.43403)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "layer1-8",
    transform: "translate(-3.058 4.294)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#121a1e",
      strokeWidth: 0.124724,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "g1928",
    transform: "matrix(14.99093 0 0 14.99093 60.265 217.013)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.014 9.038c0-.38 0-.569-.073-.713a.676.676 0 0 0-.296-.296c-.145-.074-.334-.074-.713-.074h-1.894c-.378 0-.568 0-.712.074a.676.676 0 0 0-.296.296c-.074.144-.074.334-.074.713v1.893c0 .38 0 .569-.073.713a.676.676 0 0 1-.296.296c-.145.073-.334.073-.713.073H6.98c-.378 0-.568 0-.713.074a.676.676 0 0 0-.295.296c-.074.144-.074.334-.074.713v1.893c0 .38 0 .569.074.713.065.128.168.231.295.296.145.074.335.074.713.074h1.894c.379 0 .568 0 .713.073.127.065.23.169.296.296.073.145.073.334.073.713v1.893c0 .38 0 .569.074.713.065.128.168.231.296.296.144.074.334.074.712.074h1.894c.379 0 .568 0 .713-.074a.676.676 0 0 0 .296-.296c.073-.144.073-.334.073-.713v-1.893c0-.38 0-.568.074-.713a.676.676 0 0 1 .296-.296c.144-.073.334-.073.713-.073h1.893c.38 0 .569 0 .713-.074a.676.676 0 0 0 .296-.296c.073-.144.073-.334.073-.713v-1.893c0-.38 0-.569-.073-.713a.676.676 0 0 0-.296-.296c-.144-.074-.334-.074-.713-.074h-1.893c-.38 0-.569 0-.713-.073a.676.676 0 0 1-.296-.296c-.074-.144-.074-.334-.074-.713z",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path1919",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#121a1e",
      strokeWidth: 0.124724,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.003 19.707c.065.127.168.23.296.295.144.074.334.074.712.074h1.894c.38 0 .568 0 .713-.074a.676.676 0 0 0 .296-.295c.073-.145.073-.335.073-.713V17.1Z",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path81636",
    style: {
      fill: "#18aee6",
      fillOpacity: 1,
      stroke: "#121a1e",
      strokeWidth: 0.124724,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6462",
    transform: "matrix(1.7816 0 0 1.7816 51.935 -20.638)",
    style: {
      fill: "#274f63",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#274f63",
      fillOpacity: 1,
      strokeWidth: 0.264583
    },
    d: "M101.79 291.515c-2.932-1.756-3.934-4.671-2.609-7.592.762-1.678 3.452-4.174 7.043-6.535 5.435-3.573 6.915-5.423 6.162-7.705-.696-2.107-2.735-3.654-9.128-6.924-4.029-2.061-5.969-3.614-7.04-5.637-.485-.916-.608-1.57-.612-3.263-.004-1.812.108-2.344.774-3.7 1.465-2.984 5.41-6.276 12.318-10.277 3.22-1.864 3.845-2.516 3.813-3.98-.032-1.49-.702-2.43-2.615-3.667l-1.594-1.03-.086 3.654-.086 3.655-1.7 1.13-1.7 1.13v-11.286l-1.894-.911c-5.388-2.593-6.052-6.604-1.49-8.996.54-.283 1.033-.514 1.097-.514.063 0 .192.982.286 2.183.302 3.86.383 4.156 1.3 4.715.458.28 1.607.763 2.553 1.075.946.311 2.18.798 2.742 1.08.672.338 1.262.454 1.72.339.672-.169.678-.188.184-.55-.281-.206-1.918-.924-3.637-1.596l-3.126-1.223v-5.113c0-4.726-.042-5.185-.558-6.059-.738-1.251-.516-2.506.612-3.455 1.075-.905 2.384-.737 3.477.445.666.721.73.939.565 1.907-.103.6-.238 3.716-.299 6.923l-.111 5.83 1.001.356c1.648.585 4.614 2.42 5.985 3.702 1.785 1.67 2.293 2.774 2.29 4.974-.005 3.745-1.98 6.179-8.711 10.737-7.224 4.892-8.484 6.153-8.484 8.487 0 1.96 1.049 2.89 6 5.313 8.168 3.997 10.796 6.585 10.785 10.624-.01 3.805-2.328 6.787-7.934 10.209-3.561 2.173-5.86 4.02-6.526 5.243-.597 1.097-.504 2.55.225 3.518.622.824 1.97 1.79 2.254 1.615.12-.074.142-1.534.05-3.246l-.168-3.113 1.295-1.029a75.896 75.896 0 0 1 1.56-1.218c.763 1.958-.406 8.87.473 9.996 2.436 2.262 8.927 2.744 8.668 3.047-1.297.468-14.257-2.75-15.124-3.268zm2.94-20.824c0-3.364.063-6.116.14-6.116.076 0 .85.359 1.72.798l1.58.797v8.15l-.993.776c-.546.426-1.32.986-1.72 1.243l-.727.468zm1.257-12.747-1.522-.786V249.596l1.691-1.242c.93-.683 1.764-1.241 1.853-1.241.09 0 .113 1.399.053 3.108-.06 1.71-.12 4.33-.134 5.821-.013 1.492-.113 2.707-.222 2.7-.109-.007-.883-.367-1.72-.798z",
    id: "path3260"
  })))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontSize: "72.6452px",
      lineHeight: 1.25,
      fontFamily: "Gaoel",
      InkscapeFontSpecification: "Gaoel",
      fill: "#fff",
      fillOpacity: 1,
      strokeWidth: 0.313126
    },
    x: 108.594,
    y: 84.214,
    id: "text1555",
    transform: "scale(.84497 1.18347)"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1553",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 800,
      fontStretch: "normal",
      fontSize: "72.6452px",
      fontFamily: "'Zabal DEMO'",
      InkscapeFontSpecification: "'Zabal DEMO Ultra-Bold'",
      fill: "#fff",
      fillOpacity: 1,
      strokeWidth: 0.313126
    },
    x: 108.594,
    y: 84.214
  }, "MedStock")))), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style42058"
  }, ".st0{fill:#231f20}")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMSorizzWhite1);
export default __webpack_public_path__ + "static/media/logoMSorizz-white1.6efa8332377ffd8aad2a73ae0a505407.svg";
export { ForwardRef as ReactComponent };